import { useQuery } from '@tanstack/react-query'

import { AnnotationUniqueAIObjectResponse } from '@tabeeb/contracts/microservices/swagger-ai-service'
import { useApi } from '@tabeeb/modules/shared/utils/API/hooks'
import { useMemo } from 'react'
import { AIQueryKeys } from '../queries'

interface UseAnnotationUniqueAIObjectsHookProps {
  aiAnnotationIds: number[]
  enabled?: boolean
}

interface UseAnnotationUniqueAIObjectsHookState {
  loading: boolean
  annotationUniqueAIObjects: AnnotationUniqueAIObjectResponse[]
}

const useAnnotationUniqueAIObjects = ({
  aiAnnotationIds,
  enabled = true,
}: UseAnnotationUniqueAIObjectsHookProps): UseAnnotationUniqueAIObjectsHookState => {
  const { aiServiceApi: api } = useApi()

  const query = useQuery({
    queryKey: [AIQueryKeys.AnnotationUniqueAIObjects, aiAnnotationIds],
    queryFn: () => api.annotationAiObjects.getAnnotationUniqueAiObjectsAsync({ AnnotationIds: aiAnnotationIds }),
    enabled: enabled && aiAnnotationIds.length > 0,
  })

  return useMemo(
    () => ({ loading: query.isFetching, annotationUniqueAIObjects: query.data || [] }),
    [query.isFetching, query.data]
  )
}

export default useAnnotationUniqueAIObjects
